<template>
  <div id="unitExplorer">

    <!-- FILTERS -->
    <div v-if="showFilters" class="o-modal">
      <div class="o-modal-content">
        <div class="o-modal-header">
          <a
            @click="showFilters = false"
            class="close clickable"
          ><i class="fas fa-times"></i></a>
          <p class="lead">Filter Units</p>
        </div><!-- /.o-modal-header -->
        <div class="o-modal-body">
          <b-form>
            <div class="row">
              <div class="col-sm-6">
                <b-form-group class="form-group">
                  <b-form-checkbox
                    v-model="filters.unit_available.value"
                    value="True"
                    checked-value="True"
                    unchecked-value="False"
                  >Unit Available</b-form-checkbox>
                </b-form-group>
              </div><!-- /.col-sm-6 -->
              <div class="col-sm-6">
                <b-form-group class="form-group">
                  <b-form-radio v-model="filters.type.value" value="Office/Commercial">Office/Commercial</b-form-radio>
                  <b-form-radio v-model="filters.type.value" value="Apartment/Loft">Apartment/Loft</b-form-radio>
                </b-form-group>
              </div><!-- /.col-sm-6 -->
            </div><!-- /.row -->
            <div class="row">
              <div class="col-sm-6">
                <b-form-group class="form-group">
                  <label><strong>Bedrooms</strong></label>
                  <b-input-group prepend="min" class="mb-1">
                    <b-form-select v-model="filters.bedrooms.min" :options="filters.bedrooms.options"></b-form-select>
                  </b-input-group>
                  <b-input-group prepend="max">
                    <b-form-select v-model="filters.bedrooms.max" :options="filters.bedrooms.options"></b-form-select>
                  </b-input-group>
                </b-form-group>
              </div><!-- /.col-sm-6 -->
              <div class="col-sm-6">
                <b-form-group class="form-group">
                  <label><strong>Bathrooms</strong></label>
                  <b-input-group prepend="min" class="mb-1">
                    <b-form-select v-model="filters.bathrooms.min" :options="filters.bathrooms.options"></b-form-select>
                  </b-input-group>
                  <b-input-group prepend="max">
                    <b-form-select v-model="filters.bathrooms.max" :options="filters.bathrooms.options"></b-form-select>
                  </b-input-group>
                </b-form-group>
              </div><!-- /.col-sm-6 -->
            </div><!-- /.row -->
            <div class="row">
              <div class="col-sm-6">
                <b-form-group class="form-group">
                  <label><strong>Price</strong></label>
                  <b-input-group prepend="min" class="mb-1">
                    <b-form-input v-model="filters.price.min" type="number" class="price-field"></b-form-input>
                  </b-input-group>
                  <b-input-group prepend="max">
                    <b-form-input v-model="filters.price.max" type="number" class="price-field"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div><!-- /.col-sm-6 -->
            </div><!-- /.row -->
          </b-form>
        </div><!-- /.o-modal-body -->
        <div class="o-modal-footer">
          <button @click="filterUnits" class="btn btn-primary float-right">Submit</button>
        </div><!-- /.o-modal-footer -->
      </div><!-- /.o-modal-content -->
    </div><!-- /.o-modal -->

    <!-- BUTTONS MENU -->
    <div class="buttons-menu">
      <button @click="showFilters = true" class="btn btn-primary btn-filter"><i class="fas fa-filter"></i> Filter</button>
      <b-dropdown text="Sort" class="dropdown-btn">
        <b-dropdown-item @click="sortUnits('price', 'desc')">Price Low to High</b-dropdown-item>
        <b-dropdown-item @click="sortUnits('price', 'asc')">Price High to Low</b-dropdown-item>
      </b-dropdown>
      <button @click="quickFilter('price', 0, 999)" class="btn btn-primary btn-filter hide-mobile">$0 - $999</button>
      <button @click="quickFilter('price', 1000, 1500)" class="btn btn-primary btn-filter hide-mobile">$1000 - $1500</button>
      <button @click="quickFilter('price', 1501, 2000)" class="btn btn-primary btn-filter hide-mobile">$1501 - $2000</button>
      <button @click="resetFilters()" class="btn btn-primary btn-filter"><i class="fas fa-redo-alt"></i></button>
    </div><!-- /.m-2 -->

    <hr>

    <!-- UNITS -->
    <div class="container-fluid units">
      <div class="row" v-for="i in rowCount">
        <div class="col-md-4" v-for="unit in itemCountInRow(i)">
          <a :href="unit.url" target="_blank">
            <div class="card">
              <div class="image-container">
                <img
                  v-if="unit.featured_image"
                  class="card-img-top"
                  :src="'https://buffalofts.com' + unit.featured_image"
                  alt="Card image cap"
                >
                <img
                  v-else-if="unit.first_gallery_image"
                  class="card-img-top"
                  :src="'https://buffalofts.com' + unit.first_gallery_image"
                  alt="Card image cap"
                >
                <div v-else class="m-5"></div>
                <span class="stats-card"><i class="fas fa-ruler"></i> {{ unit.area }}sq ft  <i class="fas fa-bed"></i> {{ unit.bedrooms }}  <i class="fas fa-shower"></i> {{ unit.bathrooms }}</span>
              </div><!-- /.image-container -->
              <div class="card-body">
                <h5 class="card-title">{{ unit.title }}</h5>
                <p v-if="unit.unit_available == 'True'" class="available-pill">Available</p>
                <p v-if="unit.date_available" class="date-available"><small><i class="fas fa-calendar-alt"></i> {{ unit.date_available }}</small></p>
                <p class="card-text">{{ unit.body }}</p>
                <span class="price-card">${{ unit.price }}</span>
              </div>
            </div><!-- /.card -->
          </a>
        </div><!-- /.col-md-4 -->
      </div><!-- /.row -->
    </div><!-- /.container -->
    <hr>
  </div><!-- /#unitExplorer -->
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      loading: false,
      unitsPerRow: 3,
      allUnits: [],
      showUnits: [],
      filters: {},
      showFilters: false,
      sortBy: 'price',
      order: 'desc'
    }
  },
  created () {
    this.resetFilters()
    this.getUnits()
  },
  computed: {
    rowCount () {
      return Math.ceil(this.showUnits.length / this.unitsPerRow);
    }
  },
  methods: {
    itemCountInRow (index) {
      return this.showUnits.slice((index - 1) * this.unitsPerRow, index * this.unitsPerRow)
    },
    quickFilter (filter, min, max) {
      this.filters[filter].min = min
      this.filters[filter].max = max
      this.filterUnits()
    },
    resetFilters () {
      this.showUnits = this.allUnits
      this.sortBy = 'price'
      this.order = 'desc'
      this.filters = {
        unit_available: {
          type: 'match',
          value: 'True'
        },
        type: {
          type: 'match',
          value: 'Apartment/Loft'
        },
        bedrooms: {
          type: 'range',
          min: 0,
          max: 3,
          options: [
            { value: 0, text: '0' },
            { value: 1, text: '1' },
            { value: 2, text: '2' },
            { value: 3, text: '3' }
          ]
        },
        bathrooms: {
          type: 'range',
          min: 0,
          max: 3,
          options: [
            { value: 0, text: '0' },
            { value: 1, text: '1' },
            { value: 2, text: '2' },
            { value: 3, text: '3' }
          ]
        },
        price: {
          type: 'range',
          min: 0,
          max: 3000
        }
      }
      this.filterUnits()
    },
    sortUnits (sortBy, order) {
      if (sortBy && order) {
        this.sortBy = sortBy
        this.order = order
      }
      let self = this
      this.showUnits = this.showUnits.sort(function(a, b) {
        if (self.order == 'desc') {
          return a[self.sortBy] - b[self.sortBy]
        } else {
          return b[self.sortBy] - a[self.sortBy]
        }
      })
    },
    filterUnits () {
      this.showUnits = this.allUnits.filter(unit => {
        for (var key in this.filters) {
          if (this.filters[key].type === 'match') {
            if (unit[key] === undefined || unit[key] != this.filters[key].value) {
              return false
            }
          }
          if (this.filters[key].type === 'range') {
            if (unit[key] === undefined || unit[key] < this.filters[key].min || unit[key] > this.filters[key].max) {
              return false
            }
          }
        }
        return true
      })
      this.sortUnits()
      this.showFilters = false
    },
    getUnits () {
      this.loading = true
      let url = 'https://buffalofts.com/api/unit-explorer'
      axios.get(url).then(response => {
        this.allUnits = response.data
        this.allUnits.forEach(unit => {
          unit.bedrooms = Number(unit.bedrooms)
          unit.bathrooms = Number(unit.bathrooms)
          unit.price = Number(unit.price)
          unit.area = Number(unit.area)
        })
        this.showUnits = this.allUnits
        this.filterUnits()
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap');

/* .form-group {
  border: 1px solid #eee;
  padding: 20px;
  margin: 10px 5px;
  border-radius: 4px;
  min-height: 100%;
  position: relative;
  min-height: 100px;
}

.price-field {
  max-width: 80px;
} */

.buttons-menu {
  position: fixed;
  top: 0px;
  background-color: white;
  z-index: 5;
  width: 100%;
  padding: 20px;
  box-shadow: rgba(51, 51, 51, 0.3) 1px 2px 3px;
}

.btn-filter {
  border-radius: 50px;
  border: none;
  box-shadow: rgba(51, 51, 51, 0.5) 1px 2px 3px;
  transition: all 0.2s ease-in-out;
  background-color: #1396e1;
  padding: 10px 20px;
}

@media (max-width:800px) {
  .hide-mobile {
    display: none;
  }
}

.units {
  margin-top: 90px;
}

.row {
  margin-top: 20px;
}

a {
  color: #333;
}

a:hover {
  color: #333;
  text-decoration: none;
}

.card {
  position: relative;
  border: 1px #eee solid;
  transition: all 0.2s ease-in-out;
  min-height: 100%;
}

.card:hover {
  box-shadow: rgba(51, 51, 51, 0.2) 1px 2px 3px;
  transform: scale(1.04);
}

.card-title {
  font-size: 18px;
  font-family: 'Montserrat', sans-serif;
}

.available-pill {
  background-color: #1396e0;
  display: inline-block;
  min-width: 10px;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border-radius: 10px;
}

.btn-primary {
  background-color: #1396e0;
}

.card-text {
  font-size: 14px;
  font-family: 'Open Sans', sans-serif;
}

.price-card {
  position: absolute;
  top: 5px;
  left: 5px;
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3);
  background-color: #1396e2;
  color: #fff;
  font-weight: bold;
  padding: 3px 8px;
  border-radius: 2px;
}

.image-container {
  position: relative;
}

.stats-card {
  font-size: 16px;
  bottom: 4px;
  border-radius: 2px;
  right: 20px;
  color: #000;
  padding: 5px 10px 5px 0;
  background-color: #fff;
  z-index: 3;
  position: absolute;
  bottom: 5px;
  right: 5px;
}

.stats-card i {
  margin-left: 10px;
}

.o-modal {
  background-color: rgba(0,0,0,0);
  max-height: 500px;
}

@media (max-width:800px) {
  .o-modal {
    max-height: 350px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UnitExplorer.vue